import { render, staticRenderFns } from "./AttachingDocuments.vue?vue&type=template&id=72e50408&scoped=true"
import script from "./AttachingDocuments.vue?vue&type=script&lang=js"
export * from "./AttachingDocuments.vue?vue&type=script&lang=js"
import style0 from "./AttachingDocuments.vue?vue&type=style&index=0&id=72e50408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e50408",
  null
  
)

export default component.exports